module.exports = __webpack_public_path__ + "img/view_permissions.341f041d.svg";